export default __webpack_public_path__ + "static/media/Grupo 159.9f116df4.svg";